import React from 'react';
import PropTypes from 'prop-types';

const OnlineIcon = ({
  'data-cy': dataCy,
  className,
  color = 'inherit',
  desc = 'Offered online',
  title = 'Offered online',
}) => {
  return (
    <svg
      className={className}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 1000 1000"
      style={{ fill: color, enableBackground: 'new 0 0 1000 1000' }}
      aria-label={desc}
      data-cy={dataCy}
    >
      <title>{title}</title>
      <desc>{desc}</desc>
      <g transform="translate(-1 -3)">
        <path
          fill="inherit"
          d="M967.55,102.72H34.17c-18.4,0-33.31,14.91-33.31,33.31v600.03c0,18.4,14.91,33.31,33.31,33.31h366.71v66.67
          H271.19c-20.44,0-37.02,16.57-37.02,37.02v29.66h533.36v-29.66c0-20.44-16.57-37.02-37.02-37.02H600.89v-66.67h366.66
          c18.4,0,33.31-14.91,33.31-33.31c0,0,0,0,0,0V136.03C1000.86,117.63,985.94,102.72,967.55,102.72L967.55,102.72z M934.24,702.75
          H67.53V169.39h866.66L934.24,702.75z"
        />
      </g>
    </svg>
  );
};

export default OnlineIcon;

OnlineIcon.propTypes = {
  'data-cy': PropTypes.string,
  className: PropTypes.string,
  color: PropTypes.string,
  desc: PropTypes.string,
  title: PropTypes.string,
};
